(function () {
  document.addEventListener("DOMContentLoaded", function () {
    var BD_Modal = function(container, onOpen = null, onClose = null) {
      var overlay = container.querySelector("[js-bd-modal-overlay]");

      var content = container.querySelector("[js-bd-modal-content]");
      
      var closeButton = container.querySelector("[js-bd-modal-close]");

      function open() {
        if (overlay) {
          overlay.classList.add("open");
        }
        if (content) {
          content.classList.add("open");
        }
        if (onOpen && typeof(onOpen) === "function") {
          onOpen();
        }
      }

      function close() {
        if (overlay) {
          overlay.classList.remove("open");
        }
        if (content) {
          content.classList.remove("open");
        }
        if (onClose && typeof(onClose) === "function") {
          onClose();
        }
      }

      function init() {
        closeButton.addEventListener("click", () => {
          close(container);
        });
        overlay.addEventListener("click", () => {
          close(container);
        });
      }
  
      return {
        init,
        open,
        close
      }
    };

    var BD_ProductIngredients = document.querySelector(".product__ingredients");

    if (BD_ProductIngredients) {
      var productWrapper = BD_ProductIngredients.closest(".product");
      var onOpen = function() {
        if (productWrapper) {
          productWrapper.classList.add("popup-active");
        }
      }
      var onClose = function() {
        if (productWrapper) {
          productWrapper.classList.remove("popup-active");
        }
      }
      var modal = BD_Modal(BD_ProductIngredients, onOpen, onClose);
      BD_ProductIngredients.querySelector("[js-bd-modal-button]").addEventListener("click", function() {
        modal.open();
      });
      modal.init();
    }

    var BD_Collapsible = (() => {
      var initialize = () => {
        document.querySelectorAll('[js-bd-collapsible]').forEach((root) => {
          root.querySelectorAll('[js-bd-collapsible-item]').forEach((item) => {
            var toggle = item.querySelector('[js-bd-collapsible-toggle]');
            var content = item.querySelector('[js-bd-collapsible-content]');
            if (!toggle || !content) return;

            var onToggle = () => {
              var expanded = item.getAttribute('aria-expanded') === 'true';
              item.setAttribute('aria-expanded', expanded ? 'false' : 'true');
            };

            toggle.removeEventListener('click', onToggle);
            toggle.addEventListener('click', onToggle);
          });
        });
      };

      return { init: initialize };
    })();

    BD_Collapsible.init();

    var BD_GuaranteeCards = document.querySelector(".bd-guarantee__cards");

    if (BD_GuaranteeCards) {
      var swiper = null;

      function initSwiper() {
        console.log("gegege");
        if (swiper != null) return;
        console.log("heere");
        swiper = new Swiper(".bd-guarantee__cards", {
          slidesPerView: 1.35,
          spaceBetween: 12,   
          centeredSlides: true,
          watchSlidesProgress: true,
          draggable: true, 
          autoHeight: false, 
          watchOverflow: true, 
          threshold: 10, 
          mousewheel: {
            forceToAxis: true 
          },
          loop: true
        });
      }

      function destroySwiper() {
        if (swiper) {
          swiper.destroy();
          swiper = null;
        }
      }

      function checkSwiper() {
        if (window.innerWidth >= 960) {
          destroySwiper();
        } else {
          initSwiper();
        }
      }
      
      checkSwiper();

      window.addEventListener("resize", checkSwiper);
    }

    var BD_QuantitySelector = document.querySelector(".product__custom-quantity-selector");

    if (BD_QuantitySelector) {
      var cards = BD_QuantitySelector.querySelectorAll(".product__custom-quantity-selector-card");
      var variantSelects = document.querySelectorAll("select[data-index]");
      cards.forEach(card => {
        card.addEventListener("click", function(e) {
          var currentSelected = BD_QuantitySelector.querySelector(".product__custom-quantity-selector-card--selected");

          if (currentSelected) {
            currentSelected.classList.remove("product__custom-quantity-selector-card--selected");
          }
          
          this.classList.add("product__custom-quantity-selector-card--selected");

          var unitPrice = this.getAttribute("data-card-unit-price");

          BD_QuantitySelector.querySelector(".product__custom-quantity-selector-subtitle").textContent = unitPrice;
          
          var variantValue = this.getAttribute("data-variant-value");

          if (variantValue) {
            variantSelects.forEach(select => {
              const matchingOption = [...select.options].find(
                opt => opt.value.trim() === variantValue
              );
              if (matchingOption) {
                matchingOption.selected = true;
                select.dispatchEvent(new Event("change", { bubbles: true }));
              }
            });
          }
        });
      })
    }

    var initMobileProductListSwiper = function(container) {
      var swiper = null;

      var init = false;

      function initSwiper() {
        var desktop = window.matchMedia('(min-width: 80em)');

        if (desktop.matches) {
          if (swiper) {
            swiper.destroy();
            init = false;
          }
        } else {
          if (!init) {
            new Swiper(container, {
              slidesPerView: "auto",
              spaceBetween: 22,   
              loop: true,   
              slidesPerGroup: 1,
              watchSlidesProgress: true,
              draggable: true, 
              autoHeight: false, 
              watchOverflow: true, 
              threshold: 10, 
              mousewheel: {
                forceToAxis: true,
                sensitivity: .3,
              }
            });
            init = true;
          }
        }
      }

      window.addEventListener('load', function() {
        initSwiper();
      });
      
      window.addEventListener('resize', function() {
        initSwiper();
      });
    }

    var BD_ProductLists = document.querySelectorAll("[js-bd-product-list]");

    if (BD_ProductLists) {
      BD_ProductLists.forEach(function(container) {
        initMobileProductListSwiper(container);
      });
    }

    var BD_RelatedProducts = document.querySelector(".bd-related-products");

    if (BD_RelatedProducts) {
      var container = document.querySelector(".bd-related-products");
      var { limit, productId: id, sectionId } = container.dataset;
      var requestUrl = `${window.theme.routes.productRecommendations}?section_id=${sectionId}&limit=${limit}&product_id=${id}`;
      fetch(requestUrl)
        .then((response) => {
          if (!response.ok) {
            const error = new Error(response.status);
            this.hideRelated();
            throw error;
          }
          return response.text();
        })
        .then((data) => {
          const createdElement = document.createElement('div');
          createdElement.innerHTML = data;

          const inner = createdElement.querySelector(".swiper-wrapper");

          if (!inner) return;

          if (inner.querySelectorAll(".bd-product-item").length) {
            container.querySelector(".swiper-wrapper").innerHTML = inner.innerHTML;

            initMobileProductListSwiper(container.querySelector(".bd-related-products__list"));
          }
        });
    }

    var BD_ProductPromotion = document.querySelector(".bd-product-promotion");

    if (BD_ProductPromotion) {
      var iconList = BD_ProductPromotion.querySelector(".bd-product-promotion__icon-list");
      if (iconList) {
        new Swiper(BD_ProductPromotion.querySelector(".bd-product-promotion__icon-list"), {
          slidesPerView: "auto",
          spaceBetween: 0,   
          loop: true,   
          slidesPerGroup: 1,
          watchSlidesProgress: true,
          draggable: true, 
          autoHeight: false, 
          watchOverflow: true, 
          threshold: 10, 
          mousewheel: {
            forceToAxis: true,
            sensitivity: .3,
          },
          enabled: true,
          breakpoints: {
            960: {
              enabled: false,
            }
          }
        });
      }
      var promotionItems = BD_ProductPromotion.querySelectorAll(".bd-product-promotion__item");
      if (promotionItems) {
        promotionItems.forEach(function (container) {
          var modalTriggers = container.querySelectorAll(".bd-product-promotion__item-title, .bd-product-promotion__item-button");
          var modalTarget = container.getAttribute("data-bd-modal");
          var modalContainer = document.getElementById(modalTarget);
          
          if (!modalTriggers || !modalContainer) {
            return;
          }

          var modal = BD_Modal(modalContainer);

          modalTriggers.forEach(function(trigger) {
            trigger.addEventListener("click", function() {
              modal.open();
            });
          });

          modal.init();
        });
      }
    }

    var BD_Routine = document.querySelector(".bd-routine");

    if (BD_Routine) {
      let tabs = BD_Routine.querySelectorAll(".bd-routine__tab");

      let panels = BD_Routine.querySelectorAll(".bd-routine__panel");

      tabs.forEach((tab) => {
        tab.addEventListener("click", function() {
          var targetIndex = this.getAttribute("data-routine-index");

          tabs.forEach((t) => t.classList.remove("bd-routine__tab--active"));

          panels.forEach((p) => {
            console.log("p", p);
            p.classList.remove("bd-routine__panel--active")
          });

          this.classList.add("bd-routine__tab--active");

          var targetPanel = BD_Routine.querySelector(
            ".bd-routine__panel[data-routine-index=\"" + targetIndex + "\"]"
          );

          if (targetPanel) {
            targetPanel.classList.add("bd-routine__panel--active");
          }
        });
      });

      panels.forEach(panel => {
        new Swiper(panel.querySelector(".bd-routine__products"), {
          slidesPerView: "auto",
          spaceBetween: 16,   
          // loop: true,   
          // slidesPerGroup: 1,
          // watchSlidesProgress: true,
          draggable: true, 
          autoHeight: false, 
          watchOverflow: true, 
          threshold: 10, 
          mousewheel: {
            forceToAxis: true,
            sensitivity: .3,
          },
          enabled: true,
          breakpoints: {
            686: {
              enabled: false,
              spaceBetween: 0
            }
          }
        });
      });
    }

    var BD_CollapsibleGroup = document.querySelector("[js-bd-collapsible-group]");

    if (BD_CollapsibleGroup) {
      let tabs = BD_CollapsibleGroup.querySelectorAll(".bd-collapsible-group__tab");
      
      let panels = BD_CollapsibleGroup.querySelectorAll(".bd-collapsible-group__panel");
      
      tabs.forEach((tab) => {
        tab.addEventListener("click", function() {
          var targetIndex = this.getAttribute("data-group-index");

          tabs.forEach((t) => t.classList.remove("bd-collapsible-group__tab--active"));
          panels.forEach((p) => p.classList.remove("bd-collapsible-group__panel--active"));

          this.classList.add("bd-collapsible-group__tab--active");

          var targetPanel = BD_CollapsibleGroup.querySelector(
            ".bd-collapsible-group__panel[data-group-index=\"" + targetIndex + "\"]"
          );

          if (targetPanel) {
            targetPanel.classList.add("bd-collapsible-group__panel--active");
          }
        });
      });

      var swiper = null;

      var init = false;

      function initSwiper() {
        var desktop = window.matchMedia('(min-width: 60em)');

        if (desktop.matches) {
          if (swiper) {
            swiper.destroy();
            init = false;
          }
        } else {
          if (!init) {
            swiper = new Swiper(BD_CollapsibleGroup.querySelector(".bd-collapsible-group__tabs"), {
              slidesPerView: "auto",
              spaceBetween: 0,   
              draggable: true, 
              watchOverflow: true, 
              threshold: 10, 
              mousewheel: {
                forceToAxis: true,
                sensitivity: .3,
              },
              enabled: true,
              breakpoints: {
                960: {
                  enabled: false,
                }
              }
            });
            init = true;
          }
        }
      }

      window.addEventListener('load', function() {
        initSwiper();
      });
      
      window.addEventListener('resize', function() {
        initSwiper();
      });
    }

    var BD_Contact = document.querySelector(".bd-contact");

    if (BD_Contact) {
      let tabs = BD_Contact.querySelectorAll(".bd-contact__tab");
      let panels = BD_Contact.querySelectorAll(".bd-contact__panel");

      tabs.forEach((tab) => {
        tab.addEventListener("click", function() {
          var targetTab = this.getAttribute("data-contact-tab");

          tabs.forEach((t) => t.classList.remove("bd-contact__tab--active"));
          panels.forEach((p) => p.classList.remove("bd-contact__panel--active"));

          this.classList.add("bd-contact__tab--active");

          var targetPanel = BD_Contact.querySelector(
            ".bd-contact__panel[data-contact-panel=\"" + targetTab + "\"]"
          );

          if (targetPanel) {
            targetPanel.classList.add("bd-contact__panel--active");
          }
        });
      });
    }

    var BD_FeaturedReviews = document.querySelectorAll(".bd-featured-reviews__card-list");

    if (BD_FeaturedReviews) {
      BD_FeaturedReviews.forEach(function(container) {
        new Swiper(container, {
          slidesPerView: 1,
          spaceBetween: 24,
          slidesPerGroup: 1,
          threshold: 10,
          mousewheel: {
            forceToAxis: true,
            sensitivity: 0.3,
          },
          pagination: {
            el: ".bd-featured-reviews__pagination",
            clickable: true,
            type: "bullets",
          },
          breakpoints: {
            960: {
              slidesPerView: 4,
              spaceBetween: 0,
              centeredSlides: true,
              loop: true,
              spaceBetween: 20
            }
          }
        });
      })
    }

    var BD_IconTextCards = document.querySelectorAll(".bd-icon-text__cards");

    if (BD_IconTextCards) {
      BD_IconTextCards.forEach(container => {
        var swiper = null;

        var init = false;

        function initSwiper() {
          var desktop = window.matchMedia('(min-width: 80rem)');

          if (desktop.matches) {
            if (swiper) {
              swiper.destroy();
              init = false;
            }
          } else {
            if (!init) {
              swiper = new Swiper(container, {
                slidesPerView: 1.35,
                spaceBetween: 12,   
                centeredSlides: true,
                watchSlidesProgress: true,
                draggable: true, 
                autoHeight: false, 
                watchOverflow: true, 
                threshold: 10, 
                mousewheel: {
                  forceToAxis: true 
                },
                loop: true,
                enabled: true
              });
              init = true;
            }
          }
        }

        window.addEventListener('load', function() {
          initSwiper();
        });
        
        window.addEventListener('resize', function() {
          initSwiper();
        });
      });
    }

    var BD_Header = document.querySelector(".bd-header");

    if (BD_Header) {
      var root = document.documentElement;

      var header = BD_Header

      const setHeaderHeight = () => {
        const h = header.getBoundingClientRect().height;
        root.style.setProperty("--header-height", Math.max(0, Math.round(h)) + "px");
      };

      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", setHeaderHeight, { once: true });
      } else {
        setHeaderHeight();
      }

      window.addEventListener("load", setHeaderHeight, { once: true });

      if (window.ResizeObserver) {
        const ro = new ResizeObserver(() => setHeaderHeight());
        ro.observe(header);
        header.querySelectorAll("*").forEach(el => ro.observe(el));
      }

      const onViewportChange = () => requestAnimationFrame(setHeaderHeight);

      window.addEventListener("resize", onViewportChange);

      if (window.visualViewport) {
        visualViewport.addEventListener("resize", onViewportChange);
      }

      window.addEventListener("orientationchange", onViewportChange);

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(setHeaderHeight);
      }

      let ticking = false;
      
      window.addEventListener("scroll", () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(() => {
            setHeaderHeight();
            ticking = false;
          });
        }
      }, { passive: true });
    }

    var BD_MegaMenuTriggers = document.querySelectorAll(".navigation__submenu-trigger");

    if (BD_MegaMenuTriggers) {
      BD_MegaMenuTriggers.forEach(trigger => {
        const submenu = trigger.nextElementSibling;
    
        if (!submenu) return;
    
        trigger.addEventListener("mouseenter", () => {
          submenu.classList.add("active");
        });

        trigger.addEventListener("mouseleave", (e) => {
          if (!submenu.contains(e.relatedTarget)) {
            submenu.classList.remove("active");
          }
        });

        submenu.addEventListener("mouseenter", () => {
          submenu.classList.add("active");
        });
    
        submenu.addEventListener("mouseleave", (e) => {
          if (!trigger.contains(e.relatedTarget)) {
            submenu.classList.remove("active");
          }
        });
      });
    }

    var BD_MegaMenuMobileStyle1 = document.querySelectorAll(".mega-menu--mobile.mega-menu--style_1");

    if (BD_MegaMenuMobileStyle1.length > 0) {
      BD_MegaMenuMobileStyle1.forEach(container => {
        new Swiper(container, {
          slidesPerView: "auto",
          spaceBetween: 0,
          draggable: true,
          watchOverflow: true,
          threshold: 10,
          mousewheel: {
            forceToAxis: true,
            sensitivity: 0.3,
          },
          enabled: true,
          breakpoints: {
            960: {
              enabled: false
            }
          }
        });
      });
    }

    var BD_QuickSearchSuggest = document.querySelector(".quick-search__suggest-list");

    if (BD_QuickSearchSuggest) {
      new Swiper(BD_QuickSearchSuggest, {
        slidesPerView: "auto",
        spaceBetween: 0,
        draggable: true,
        watchOverflow: true,
        threshold: 10,
        mousewheel: {
          forceToAxis: true,
          sensitivity: 0.3,
        },
        enabled: true,
        breakpoints: {
          960: {
            enabled: false
          }
        }
      });
    }

    var BD_QuickSearchClose = document.querySelector(".bd-header .header__left .quick-search__close");

    if (BD_QuickSearchClose) {
      BD_QuickSearchClose.addEventListener("click", function() {
        var quickSearchOverlay = document.querySelector(".quick-search__overlay");
        if (quickSearchOverlay) {
          quickSearchOverlay.click();
        }
      });
    }

    var BD_CollectionBannerIconList = document.querySelectorAll(".bd-collection-banner__icon-list");

    if (BD_CollectionBannerIconList) {
      BD_CollectionBannerIconList.forEach(function(container) {
        new Swiper(container, {
          slidesPerView: "auto",
          spaceBetween: 0,
          draggable: true,
          watchOverflow: true,
          threshold: 10,
          mousewheel: {
            forceToAxis: true,
            sensitivity: 0.3,
          },
          enabled: true,
          breakpoints: {
            960: {
              enabled: false
            }
          }
        });
      })
    }

    var BD_AuthorListSections = document.querySelectorAll(".bd-author-list__grid");

    if (BD_AuthorListSections) {
      BD_AuthorListSections.forEach(function(container) {
        var swiper = null;

        var init = false;

        function initSwiper() {
          var desktop = window.matchMedia('(min-width: 60em)');

          if (desktop.matches) {
            if (!init) {
              swiper = new Swiper(container, {
                slidesPerView: "auto",
                centeredSlides: true,
                loop: true,
                spaceBetween: 20,
                watchOverflow: true,
                slidesPerGroup: 1,
                threshold: 10,
                mousewheel: {
                  forceToAxis: true,
                  sensitivity: 0.3,
                }
              });
            }
            init = true;
            
          } else {
            if (swiper) {
              swiper.destroy();
              init = false;
            }
          }
        }

        window.addEventListener('load', function() {
          initSwiper();
        });
        
        window.addEventListener('resize', function() {
          initSwiper();
        });
      });
    }

    var BD_IconTextCircles = document.querySelectorAll("[js-bd-icon-text-circle]");

    if (BD_IconTextCircles) {
      BD_IconTextCircles.forEach(function (container) {
        var swiper = null;

        var init = false;

        function initSwiper() {
          if (window.matchMedia('(min-width: 60em)').matches) {
            if (swiper) {
              swiper.destroy();
              init = false;
            }
          } else {
            if (!init) {
              new Swiper(container, {
                slidesPerView: "auto",
                spaceBetween: 0,   
                loop: true,   
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                draggable: true, 
                autoHeight: false, 
                watchOverflow: true, 
                threshold: 10, 
                mousewheel: {
                  forceToAxis: true,
                  sensitivity: .3,
                },
              });
              init = true;
            }
          }
        }

        window.addEventListener('load', function() {
          initSwiper();
        });
        
        window.addEventListener('resize', function() {
          initSwiper();
        });
      });
    }
  });
})();